import { Button } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { useStores } from 'src/js/hook/use-stores';
import { StatisticTable } from 'src/js/pages/statistic/statistic-table';

import { AudioEncoderViewModel } from './audio-encoder-models';
import { mapAudEncToStatistics } from './audio-encoder-statistics-content';
import { fetchAudioEncoderStatistics, resetAudioEncoderStatistics } from './audio-encoder-store';

interface Props {
  model: AudioEncoderViewModel;
}

export const AudioEncoderStatistics: React.FunctionComponent<Props> = ({ model }) => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [data, setData] = useState(model);
  useAdaptiveFetch(() => fetchAudioEncoderStatistics(model, t, setData), 5000); // FIXME does the arrow function returns the promise?

  const handleResetStatistics = () => {
    resetAudioEncoderStatistics(model, t, setData);
  };

  return (
    <>
      <div className="mk-stats-container">
        <StatisticTable sections={mapAudEncToStatistics(data, t)} />
      </div>
      {!sessionStore.isUser() && (
        <div className="d-flex hai-mt-4">
          <Button className="ml-auto" variant="secondary" onClick={handleResetStatistics}>
            {t('general.reset')}
          </Button>
        </div>
      )}
    </>
  );
};
